import { Box, styled, Tooltip as JoyTooltip, TooltipProps } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';

interface IProps extends Omit<TooltipProps, 'children'> {
  children: string | JSX.Element;
  childrenSx?: SxProps;
}

const ChildWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'inherit',
  alignItems: 'inherit',
});

const Tooltip = ({ children, childrenSx, open, followCursor, ...rest }: IProps) => {
  // The theme defaults followCursor to true, and Joy then anchors the bubble to ONE app-wide
  // last-mousemove position (0, 0 before any move), so a controlled `open` bubble would render
  // away from its child — anchor it to the child instead.
  const resolvedFollowCursor = open === undefined ? followCursor : followCursor ?? false;

  return (
    <JoyTooltip {...rest} open={open} followCursor={resolvedFollowCursor}>
      <ChildWrapper sx={childrenSx}>{children}</ChildWrapper>
    </JoyTooltip>
  );
};

export default Tooltip;
